import { PropsWithChildren } from "react";
import { styles } from "../../../theme";
import { Heading } from ".";
import {
  componentSpace,
  componentSpaceMobile,
  lineHeight,
  lineHeightMobile,
  middleSpace,
  smallSpace,
} from "../../../theme/styles";
import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { PlanCards } from "./PlanCards";
import { PlanInputButtons } from "./PlanInputButtons";

interface Props {
  id: string;
}

export const Plans = ({ id }: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <>
      <Heading
        id={id}
        variant={"h3"}
        style={
          isDesktop
            ? { lineHeight, marginTop: componentSpace }
            : {
                lineHeight,
                marginTop: componentSpaceMobile,
              }
        }
      >
        Insights de Profissional <br></br>
        acessível para <label style={styles.label}>todos</label>
      </Heading>

      <Heading
        variant={"h6"}
        style={
          isDesktop
            ? {
                fontSize: "16px",
                marginTop: smallSpace,
              }
            : {
                fontSize: "16px",
                marginTop: smallSpace,
                lineHeight: lineHeightMobile,
              }
        }
      >
        Possibilitando o treinamento de qualidade com preços acessíveis
      </Heading>

      <Grid
        container
        style={{
          marginBottom: middleSpace,
          justifyContent: "center",
        }}
      >
        <PlanInputButtons></PlanInputButtons>
      </Grid>

      <PlanCards></PlanCards>
    </>
  );
};
